const viSVG = (color = '#241247') => `
<svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path 
    fill-rule="evenodd" 
    clip-rule="evenodd" d="M7.87028 0.0602026C7.97013 0.00419467 8.0894 -0.013622 8.20305 0.0104905C8.31671 0.0346031 8.41592 0.0987708 8.47987 0.189531L8.92624 0.823577C8.98455 0.906445 9.00952 1.00585 8.99673 1.1042C8.98394 1.20256 8.93422 1.29354 8.85635 1.36105L8.855 1.36273L8.84869 1.36818L8.82299 1.39044L8.72154 1.48072C8.16019 1.98779 7.61587 2.51095 7.08935 3.04946C6.09877 4.06393 4.92242 5.39165 4.13068 6.67989C3.90975 7.03933 3.37004 7.11659 3.04992 6.80628L0.125959 3.97701C0.0840565 3.93645 0.0513381 3.88846 0.0297485 3.83589C0.00815895 3.78331 -0.00186102 3.72724 0.000284105 3.67099C0.00242923 3.61474 0.0166957 3.55946 0.0422355 3.50845C0.0677753 3.45744 0.104067 3.41173 0.148954 3.37404L1.03268 2.63166C1.11034 2.56645 1.20992 2.52841 1.31438 2.52404C1.41884 2.51968 1.52168 2.54926 1.6053 2.60772L3.09726 3.64949C5.42741 1.50927 6.74939 0.68795 7.87028 0.0602026Z" 
    fill="${color}"
/>
</svg>
`

export default viSVG



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/viSVG.js